import PropTypes from 'prop-types';
import { useSnackbar } from "notistack";
import { makeStyles } from '@material-ui/core/styles';
import React, { useState, useEffect, useRef } from "react";
import { Button, DialogActions, DialogContent } from "@material-ui/core";

import CreatedBy from './CreatedBy.js';
import BasicInfo from './BasicInfo.js';
import api from "../../../../../services/api.js";

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    },
}));

export default function FormStore(props) {
    const classes = useStyles();

    const snack = useRef()
    const { enqueueSnackbar } = useSnackbar();
    snack.current = enqueueSnackbar

    const [values, setValues] = useState({
        descricao: '',

        criado_em: '',
        criado_por: '',
        editado_em: '',
        editado_por: '',
    });

    useEffect(() => {
        if (props.data) {
            setValues(props.data)
        }
    }, [props])

    async function Update() {
        snack.current("Editando, aguarde...", { variant: 'info' })
        var update_occurrencetype = {
            '_id': values._id,
            'descricao': values.descricao,
        }
        api.put(`/occurrencetype`, { update_occurrencetype })
            .then(() => {
                props.setReload(currentIsOpen => !currentIsOpen)
                props.setOpen(false)
                snack.current("Descrição da ocorrência editada!", { variant: 'success' })
            })
            .catch((error) => {
                if (error.response.data.message) {
                    snack.current(`${error.response.data.message}`, { variant: 'error' })
                } else {
                    snack.current("Falha ao editar ocorrência!", { variant: 'error' })
                }
            });
    }

    return (
        <>
            <DialogContent className={classes.root}>
                <BasicInfo values={values} setValues={setValues} />
                <CreatedBy values={values} setValues={setValues} />
            </DialogContent >
            <DialogActions>
                <Button
                    onClick={() => { Update() }}
                >
                    Salvar
                </Button>
                <Button onClick={() => { props.setOpen(false) }}>
                    Cancelar
                </Button>
            </DialogActions>
        </>
    )
}

FormStore.propTypes = {
    setOpen: PropTypes.func,
    setReload: PropTypes.func
};
